import { type ReactNode } from 'react';
import { useMedia } from 'react-use';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import { Modal } from '../Modal/Modal';
import { Sheet } from '../Sheet/Sheet';

interface Props {
  children: ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  innerContentClassName?: string;
  onDismiss: () => void;
  ariaLabel: string;
  testid?: string;
  isOpen: boolean;
  contentBodyClassName?: string;
  swipeCloseSegmentEvent?: () => void;
  showTouchBar?: boolean;
  isSmallModal?: boolean;
  height?: 'auto' | 'full';
}

export function SheetOrModal(props: Props) {
  const {
    isOpen,
    children,
    testid,
    ariaLabel,
    onDismiss,
    contentClassName,
    contentBodyClassName,
    overlayClassName,
    swipeCloseSegmentEvent,
    innerContentClassName,
    showTouchBar,
    isSmallModal = false,
    height = 'auto',
  } = props;
  const isDesktop = useMedia(BreakpointQueryLarge, false);

  if (isDesktop === true || isSmallModal) {
    return (
      <Modal
        contentClassName={contentClassName}
        overlayClassName={overlayClassName}
        innerContentClassName={innerContentClassName}
        onDismiss={onDismiss}
        ariaLabel={ariaLabel}
        testid={testid}
        isOpen={isOpen}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Sheet
      contentClassName={contentClassName}
      className={overlayClassName}
      initialFocusRef={undefined}
      onRequestDismiss={onDismiss}
      ariaLabel={ariaLabel}
      testid={testid}
      active={isOpen}
      contentBodyClassName={contentBodyClassName}
      swipeCloseSegmentEvent={swipeCloseSegmentEvent}
      showTouchBar={showTouchBar}
      height={height}
    >
      {children}
    </Sheet>
  );
}
